// extracted by mini-css-extract-plugin
export default {"wrapper":"MainFilterGroup_wrapper__4JJmK","description":"MainFilterGroup_description__2R4zA","imgWrapper":"MainFilterGroup_imgWrapper__uPpKs","title":"MainFilterGroup_title__moGuR"};